const isServer = typeof window === 'undefined';
export const CUSTOM_BASE_URL = process.env.NEXT_PUBLIC_SITE_URL ?? (!isServer && window.location.origin);
export const FULL_URL = !isServer ? window.location.href : '';
export const CLIENT_BASE_URL = !isServer ? window.location.origin : '';
export const BASE_URL =
  process.env.NEXT_PUBLIC_APP_ENV === 'production'
    ? 'https://www.restworld.it'
    : process.env.NEXT_PUBLIC_APP_ENV === 'development'
    ? 'http://localhost:4200'
    : 'https://dev.worker.restworld.it';

export const CUSTOM_EMPLOYER_BASE_URL =
  process.env.NEXT_PUBLIC_APP_ENV === 'production'
    ? 'https://restworld.it'
    : process.env.NEXT_PUBLIC_APP_ENV === 'development'
    ? 'http://localhost:4200'
    : 'https://dev.employer.restworld.it';
